import { Box, Button, Image, Text } from '@wix/design-system'
import React, { FC } from 'react'

import { optionDataHooks as dataHooks } from './Option.dataHooks'
import s from './Option.scss'

type Props = {
  imgSrc: string
  label: string
  btn: string
  description: string
  onClick: () => void
  alt?: string
  dataHook?: string
}

export const Option: FC<Props> = ({ imgSrc, label, dataHook, alt, btn, description, onClick }) => (
  <Box
    direction="vertical"
    borderRadius="12px"
    padding="18px 18px 30px 18px"
    borderColor="#d6e6fe"
    border="1px solid"
    gap="SP3"
    width="294px"
    dataHook={dataHook}
  >
    <Image src={imgSrc} alt={alt} dataHook={dataHooks.img()} />
    <Box direction="vertical" align="center" gap="SP2" flex={1}>
      <Text weight="bold" dataHook={dataHooks.label()}>
        {label}
      </Text>
      {/* for some reason textAlign: center centers the non-existing tooltip text xD */}
      <Text dataHook={dataHooks.description()} className={s.textCenter}>
        {description}
      </Text>
    </Box>
    <Button skin="standard" priority="secondary" onClick={onClick} dataHook={dataHooks.btn()}>
      {btn}
    </Button>
  </Box>
)
